import { openDB } from "idb";

export const dbPromise = openDB("jukai-cloud", 1, {
    upgrade(db) {
        if (!db.objectStoreNames.contains("queue")) {
            const store = db.createObjectStore("queue", {
                keyPath: "id",
                autoIncrement: true
            })
        }
    }
})